<template>
    <div class="information-m">

      <div class="information" v-for="(info, index) in information" :key="index" @click="informationShow(info.content)">
        <div class="information-left">{{ info.title }} {{ info.content }}</div>
        <div class="information-right">消息</div>
      </div>

      <Floating />
      <Laod ref="laoding" />
      <wxNoShare />
    </div>
</template>

<script>
  import { Dialog } from 'vant';

  export default {
    components: {
      [Dialog.Component.name]: Dialog.Component,
    },
    name: 'information',
    data() {
      return {
        information: [],
      }
    },
    created () {
      this.getInformation()
    },
    methods: {
      getInformation() {
        this.$api.get('informations', null, r=>{
          this.information = r.data
        })
      },
      informationShow(data) {
        Dialog.alert({
          message: data,
        }).then(() => {
          // on close
        });
      }
    }
  }
</script>

<style scoped>
  .information-m{
    width: 100%;
    height: 100%;
    background-color: #ffffff;
    position: fixed;
    overflow: hidden;
  }
  .information{
    overflow: hidden;
    padding:10px 15px;
    font-size: 14px;
    border-bottom: 1px solid #eff1f3;
  }
  .information .information-left{
    float: left;
    width: 85%;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    height: 40px;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
  .information .information-right{
    float: right;
    width: 15%;
    text-align: right;
    padding-top:18px;
    color:#969799;
  }
</style>



// WEBPACK FOOTER //
// src/views/users/information.vue